import { InjectionToken, Injector } from '@angular/core';

export const MODAL_CUSTOM_DATA = new InjectionToken<unknown>('modalCustomData');

export function createModalInjector<T = any>(
  data: T,
  injector: Injector
): Injector {
  return Injector.create({
    providers: [
      {
        provide: MODAL_CUSTOM_DATA,
        useValue: data,
      },
    ],
    parent: injector,
  });
}
